import Lottie from "lottie-react";
import successAnimation from "../../assets/animations/Success.json"; 
const ClintAddedSuccessfuly = () => {
  return (
    <div className="successfuly mb_80 mt_60">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 text-center m-auto d-flex justify-content-center align-items-center flex-column">
            <Lottie
              animationData={successAnimation}
              loop={true} // plays once
              style={{ width: 200, height: 200 }}
            />
            <h2>Great job!</h2>
            <p className="my_20">
              The new client is all set. You can now move forward with company setup and payroll management.
            </p>
            <a href="/" className="btn btn_primary">
              Back To Dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClintAddedSuccessfuly;
